module.exports = __webpack_public_path__ + "static/media/fa-solid-900.c4fc4e6d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-solid-900.woff2
// module id = 760
// module chunks = 0